import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  TableRow,
  TableCell,
} from '@material-ui/core';

import moment from '../../utils/moment';
import StatusChip from '../StatusChip';
import monthName from '../../utils/monthName';

const STATUSES = {
  PENDING: 'processing',
  ERROR: 'failed',
  SUCCESS: 'successful',
};

class ProcessRow extends PureComponent {
  type(status) {
    switch (status) {
      case STATUSES.PENDING:
        return 'warning';
      case STATUSES.ERROR:
        return 'error';
      case STATUSES.SUCCESS:
        return 'success';
      default:
        return '';
    }
  }

  label(status) {
    switch (status) {
      case STATUSES.PENDING:
        return 'PENDIENTE';
      case STATUSES.ERROR:
        return 'ERROR';
      case STATUSES.SUCCESS:
        return 'LISTO';
      default:
        return '';
    }
  }

  render() {
    const {
      month,
      year,
      status_message,
      status,
      updated_at,
    } = this.props.process;

    return (
      <TableRow
        hover
        tabIndex={-1}
      >
        <TableCell width={50} padding="none">
          <StatusChip type={this.type(status)} label={this.label(status)} variant="outlined" />
        </TableCell>
        <TableCell>{`Recibos ${monthName(month)} ${year}`}</TableCell>
        <TableCell>{status_message}</TableCell>
        <TableCell width={150} padding="none">{moment(updated_at).locale('es').fromNow()}</TableCell>
      </TableRow>
    );
  }
}

export default ProcessRow;

ProcessRow.propTypes = {
  process: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Paychecks/ProcessRow.js